import React from 'react';
import { motion } from 'framer-motion';

const NUM_SPARKLES = 20;
const getRandom = (min: number, max: number) => Math.random() * (max - min) + min;

const SparklesBackground: React.FC = () => (
  <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
    {Array.from({ length: NUM_SPARKLES }).map((_, i) => {
      // Randomize initial position and animation
      const left = getRandom(5, 95); // percent
      const top = getRandom(5, 95); // percent
      const xMove = getRandom(-120, 120);
      const yMove = getRandom(-120, 120);
      const duration = getRandom(14, 28);
      const delay = getRandom(0, 4);
      const size = getRandom(0.5, 2.5);
      const opacity = getRandom(0.15, 0.35);
      return (
        <motion.div
          key={i}
          className="absolute bg-primary-400 rounded-full"
          style={{
            left: `${left}%`,
            top: `${top}%`,
            width: `${size * 0.5}rem`,
            height: `${size * 0.5}rem`,
            opacity,
          }}
          animate={{
            x: [0, xMove, 0],
            y: [0, yMove, 0],
          }}
          transition={{
            duration,
            repeat: Infinity,
            delay,
          }}
        />
      );
    })}
  </div>
);

export default SparklesBackground; 